export default {"src":"/_next/static/media/stops.416c9fdb.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};